import { FC, useLayoutEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PickerComponent from './components/Picker';
import WeekComponent from './components/Week';
import { useNavigationData } from '../../modules/NavigationProvider';
import { usePolesContext } from '../../modules/poles/PolesContext';

const SchedulePage: FC = () => {
  const navigate = useNavigate();
  const { setPath, setButtonText } = useNavigationData();
  const { currentPole, onChangeLedProfile } = usePolesContext();

  const [showPicker, setShowPicker] = useState(true);
  const [ledDays, setLedDays] = useState<number[]>([]);

  const [startHour, setStartHour] = useState<number>(0);
  const [startMinute, setStartMinute] = useState<number>(0);
  const [stopHour, setStopHour] = useState<number>(0);
  const [stopMinute, setStopMinute] = useState<number>(0);

  useLayoutEffect(() => {
    setPath('/lights');
    setButtonText();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    if (currentPole?.firmware.ledschedule) {
      const { start, stop, days } = currentPole.firmware.ledschedule;
      if (start) {
        const [currentStartHour, currentStartMinute] = start.split(':');
        setStartHour(Number(currentStartHour));
        setStartMinute(Number(currentStartMinute));
      }
      if (stop) {
        const [currentStopHour, currentStopMinute] = stop.split(':');
        setStopHour(Number(currentStopHour));
        setStopMinute(Number(currentStopMinute));
      }
      if (days?.length) setLedDays(days);
    }
  }, [currentPole]);

  const handleCancel = () => {
    onChangeLedProfile({ type: 0 });
    navigate('/lights');
  };

  const handleSave = () => {
    // Sempre Ligado
    if (
      (!ledDays.length || ledDays.length === 7) &&
      startHour === stopHour &&
      startMinute === stopMinute
    ) {
      onChangeLedProfile({ type: 0 });
    }
    // Programado
    else {
      onChangeLedProfile({
        type: 1,
        days: ledDays,
        start: `${startHour.toString().padStart(2, '0')}:${startMinute
          .toString()
          .padStart(2, '0')}`,
        stop: `${stopHour.toString().padStart(2, '0')}:${stopMinute
          .toString()
          .padStart(2, '0')}`,
      });
    }

    navigate('/lights');
  };

  return (
    <div className="d-flex justify-content-center align-items-center h-100">
      {showPicker ? (
        <PickerComponent
          time={{
            startHour,
            setStartHour,
            startMinute,
            setStartMinute,
            stopHour,
            setStopHour,
            stopMinute,
            setStopMinute,
          }}
          ledDays={ledDays}
          setShowPicker={setShowPicker}
          onCancel={handleCancel}
          onSave={handleSave}
        />
      ) : (
        <WeekComponent
          ledDays={ledDays}
          setLedDays={setLedDays}
          setShowPicker={setShowPicker}
        />
      )}
    </div>
  );
};

export default SchedulePage;
